import React from 'react';
import FormSteps from '../FormSteps';
import producingIcon from '../../../../../assets/svg/onboarding/producing-icon.svg';
import coffeeIcon from '../../../../../assets/svg/onboarding/coffee-icon.svg';
import rasingFundsIcon from '../../../../../assets/svg/onboarding/raising-funds-icon.svg';
import connectingIcon from '../../../../../assets/svg/onboarding/connecting-icon.svg';

/**
 * InterestsStep Component
 *
 * Final step for selecting user's interests
 *
 * @param {Object} formik - Formik instance with form state and methods
 * @param {Function} onSubmit - Function to handle form submission
 * @param {Function} skipStep - Function to skip to the next step
 * @param {Boolean} isSubmitting - Whether the form is currently submitting
 */
const InterestsStep = ({
  formik,
  onSubmit,
  skipStep,
  isSubmitting
}) => {
  const handleSubmit = () => {
    formik.handleSubmit();
  };

  // Interest options with icons and labels
  const interestOptions = [
    {
      id: 'producing_projects',
      label: 'Producing / joining projects',
      icon: producingIcon
    },
    {
      id: 'virtual_coffee_chats',
      label: 'Virtual coffee chats',
      icon: coffeeIcon
    },
    {
      id: 'raising_funds',
      label: 'Raising funds for projects',
      icon: rasingFundsIcon
    },
    {
      id: 'connecting_professionals',
      label: 'Connecting with industry professionals',
      icon: connectingIcon
    }
  ];

  // Handle checkbox change
  const handleInterestChange = (interestId) => {
    const currentInterests = formik.values.userInterests || [];
    const updatedInterests = currentInterests.includes(interestId)
      ? currentInterests.filter((id) => id !== interestId)
      : [...currentInterests, interestId];

    formik.setFieldValue('userInterests', updatedInterests);
  };

  return (
    <FormSteps
      header="Would you be interested in"
      description="Help others connect with you."
      nextButton={handleSubmit}
      skipButton={skipStep}
      nextButtonText="Done"
      isSubmitting={isSubmitting}
    >
      <div className="interests-grid">
        {interestOptions.map((option) => (
          <div key={option.id} className="interest-option">
            <label className="checkbox-container">
              <div className="interest-content">
                <img className="interest-icon" src={option.icon} />
                <span className="interest-label">{option.label}</span>
              </div>
              <input
                type="checkbox"
                name="userInterests"
                value={option.id}
                checked={(formik.values.userInterests || []).includes(
                  option.id
                )}
                onChange={() => handleInterestChange(option.id)}
                className="interest-checkbox"
              />
              <span className="checkmark"></span>
            </label>
          </div>
        ))}
      </div>
    </FormSteps>
  );
};

export default InterestsStep;
